export default "//pteglobalstatic.ptengine.com/pte/icons/pt-pic-exploretestingideas.svg"